import React from 'react';
import makeStyles from '@mui/styles/makeStyles';

const TitleTypeDocumentCell = ({ cell }) => {
    const classes = useStyles();

    return (
        <div>
            <div className={classes.title}>{cell.document_title}</div>
            <div className={classes.type}>{cell.document_type.replace('_', ' ')}</div>
        </div>
    );
};

const useStyles = makeStyles((theme) => ({
    title: {
        fontSize: '14px',
        fontWeight: 600,
    },
    type: {
        fontSize: '11px',
        color: '#666666',
        lineHeight: '15px',
        textTransform: 'capitalize',
    },
}));

export default TitleTypeDocumentCell;
